/* eslint-disable no-confusing-arrow */

import React from 'react';
import styledComp from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Colors, Styling } from '../../constants';
import vaultIcon from '../../images/vault_icon.png';
import tagIcon from '../../images/add-tags.svg';
import errorIcon from '../../images/upload_error.svg';
import { filterI18nProps } from '../../utils/styledComponentsUtils';

interface IIconContainerProps {
  disabled: boolean;
}
const IconContainer = styledComp.svg.withConfig({
  shouldForwardProp: (prop) => prop !== 'disabled',
})<IIconContainerProps>`
  fill: ${(props) => (props.disabled ? Colors.MEDIUM_GREY : Colors.DARK_GREY)};
  margin: 0 5px;
  opacity: 0.4;

  &:hover {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    opacity: ${(props) => (props.disabled ? 0.4 : 1)};
  }
`;

export function Icon(props: any) {
  const {
    onClick,
    disabled,
    viewBox,
    ...rest
  } = props;

  const clickHandler = disabled ? () => {} : onClick;
  const filteredRest = filterI18nProps(rest);

  return (
    <IconContainer
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox={props.viewBox || '0 0 24 24'}
      onClick={clickHandler}
      disabled={disabled}
      {...filteredRest}
    >
      {props.children}
    </IconContainer>
  );
}

export function ShareIcon(props: any) {
  return (
    <Icon {...props}>
      <path d="M21,12L14,5V9C7,10 4,15 3,20C5.5,16.5 9,14.9 14,14.9V19L21,12Z" />
    </Icon>
  );
}

export function ShareAllIcon(props: any) {
  return (
    <Icon {...props}>
      <path d="M11 9V5L18 12L11 19V14.9C6 14.9 2.5 16.5 0 20C1 15 4 10 11 9M17 8V5L24 12L17 19V16L21 12L17 8Z" />
    </Icon>
  );
}

export function RefreshIcon(props: any) {
  return (
    <Icon {...props}>
      <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
    </Icon>
  );
}

export function ReviewJobsIcon(props: any) {
  return (
    <Icon
      viewBox="0 0 55 55"
      {...props}
    >
      <path d="M42.5,31c-6.617,0-12,5.383-12,12s5.383,12,12,12s12-5.383,12-12S49.117,31,42.5,31z M42.5,53c-5.514,0-10-4.486-10-10s4.486-10,10-10s10,4.486,10,10S48.014,53,42.5,53z" />
      <path d="M48.5,42h-5v-5c0-0.553-0.447-1-1-1s-1,0.447-1,1v6c0,0.553,0.447,1,1,1h6c0.553,0,1-0.447,1-1S49.053,42,48.5,42z" />
      <path d="M27.5,14h18c0.553,0,1-0.447,1-1s-0.447-1-1-1h-18c-0.553,0-1,0.447-1,1S26.947,14,27.5,14z" />
      <path d="M27.5,28h18c0.553,0,1-0.447,1-1s-0.447-1-1-1h-18c-0.553,0-1,0.447-1,1S26.947,28,27.5,28z" />
      <path d="M21.079,7.241c-0.418-0.358-1.05-0.313-1.409,0.108l-6.248,7.288L9.6,11.771c-0.441-0.331-1.068-0.243-1.399,0.2c-0.332,0.441-0.242,1.068,0.2,1.399l4.571,3.429c0.179,0.135,0.39,0.2,0.599,0.2c0.283,0,0.563-0.119,0.76-0.35l6.857-8C21.548,8.231,21.499,7.601,21.079,7.241z" />
      <path d="M21.079,21.241c-0.418-0.359-1.05-0.312-1.409,0.108l-6.248,7.288L9.6,25.771c-0.441-0.331-1.068-0.243-1.399,0.2c-0.332,0.441-0.242,1.068,0.2,1.399l4.571,3.429c0.179,0.135,0.39,0.2,0.599,0.2c0.283,0,0.563-0.119,0.76-0.35l6.857-8C21.548,22.231,21.499,21.601,21.079,21.241z" />
      <path d="M19.67,36.35l-6.248,7.287L9.6,40.771c-0.441-0.33-1.068-0.243-1.399,0.2c-0.332,0.441-0.242,1.068,0.2,1.399l4.571,3.429c0.179,0.135,0.39,0.2,0.599,0.2c0.283,0,0.563-0.119,0.76-0.35l6.857-7.999c0.36-0.419,0.312-1.05-0.108-1.409C20.661,35.883,20.029,35.929,19.67,36.35z" />
      <path d="M42.324,0H12.676C5.962,0,0.5,5.462,0.5,12.176v29.648C0.5,48.538,5.962,54,12.676,54H27.5c0.553,0,1-0.447,1-1s-0.447-1-1-1H12.676C7.064,52,2.5,47.436,2.5,41.824V12.176C2.5,6.564,7.064,2,12.676,2h29.648C47.936,2,52.5,6.564,52.5,12.176V27c0,0.553,0.447,1,1,1s1-0.447,1-1V12.176C54.5,5.462,49.038,0,42.324,0z" />
    </Icon>
  );
}

interface IFaIconProps {
  $small?: boolean;
}
export const FaIcon = styledComp(FontAwesomeIcon)<IFaIconProps>`
  width: 1em !important;
  height: 1em !important;
  font-size: ${(props) => props.$small ? '1rem' : '1.5rem'};
`;

const VaultIconImg = styledComp.img`
  display: block;
  height: ${Styling.SOCIAL_ICON_SPACING}px;
  width: ${Styling.SOCIAL_ICON_SPACING}px;
`;

const TagArrowImg = styledComp.img`
  display: block;
`;

export const ErrorIconImg = styledComp.img`
  width: 1em !important;
  height: 1em !important;
  font-size: '1.5rem';
`;

export const VaultIcon = (props: any) => (
  <VaultIconImg {...filterI18nProps(props)} src={vaultIcon} />
);

export const TagArrowIcon = (props: any) => (
  <TagArrowImg {...filterI18nProps(props)} src={tagIcon} />
);

export const ErrorIcon = (props: any) => (
  <ErrorIconImg {...filterI18nProps(props)} src={errorIcon} />
);
